import React, { useEffect } from 'react';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { theme } from './theme/theme';
import './i18n/i18n';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import PlatformPage from './pages/PlatformPage';
import AutonomousPage from './pages/AutonomousPage';
import SecurityPage from './pages/SecurityPage';
import PartnersPage from './pages/PartnersPage';
import DemoPage from './pages/DemoPage';
import ConnectorsPage from './pages/ConnectorsPage';
import PricingPage from './pages/PricingPage';
import NotFoundPage from './pages/NotFoundPage';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  }, [pathname]);
  return null;
};

const Shell: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <Navbar />
    <Box component="main" sx={{ flex: 1 }}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/plataforma" element={<PlatformPage />} />
        <Route path="/agentes-autonomos" element={<AutonomousPage />} />
        <Route path="/seguridad" element={<SecurityPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/conectores" element={<ConnectorsPage />} />
        <Route path="/precios" element={<PricingPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Box>
    <Footer />
  </Box>
);

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang: 'es' | 'en' = i18n.language && i18n.language.startsWith('en') ? 'en' : 'es';
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', lang);
    }
  }, [i18n.language]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
